import 'rxjs'
import {
  ACTION_FEATURED_MEDIA_SETTING,
  ACTION_DROPCAPS_SETTING,
  ACTION_UPDATE_CUSTOM_EMBED,
  ACTION_DELETE_CUSTOM_EMBED,
  ACTION_SETTINGS_LOADED,
  ACTION_UPDATE_CREATE_ANNOTATION,
  ACTION_DELETE_ANNOTATION,
  getSettings,
} from '~/redux/settingsReducer'

export const settingsSyncActions = [
  ACTION_FEATURED_MEDIA_SETTING,
  ACTION_DROPCAPS_SETTING,
  ACTION_UPDATE_CUSTOM_EMBED,
  ACTION_DELETE_CUSTOM_EMBED,
  ACTION_SETTINGS_LOADED,
  ACTION_UPDATE_CREATE_ANNOTATION,
  ACTION_DELETE_ANNOTATION,
]
// Since we're moving to Redux, Angular SettingsController and SettingsService
// can no longer be a single source of truth. Settings state should be moved in to redux
// This epic invoke `retrofitSettingsToSettingsController` on any (see settingsSyncActions)
// settings modification redux action
// That way, active SettingsController will be in sync with Redux
// NOTE: This should be removed as soon as Angular settings page will be deprecated
const settingsSyncEpic = (action$, store, { serviceResolver }) =>
  action$
    .filter((action) => settingsSyncActions.indexOf(action.type) !== -1)
    .map(() => {
      const updatedSettings = getSettings(store.getState())
      serviceResolver('settingsService').retrofitSettingsToSettingsController(
        updatedSettings
      )
    })
    .filter(() => false)

export default settingsSyncEpic
